// extracted by mini-css-extract-plugin
export default {"container":"orders-card_container__BTy1h","ingredients":"orders-card_ingredients__Kmmzc","wrapper":"orders-card_wrapper__lHM7S","status":"orders-card_status__vvfF1"};